module.exports = __webpack_public_path__ + "static/media/updated_annual.a0ae0792.svg";